;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.RoundTipsStat = Marionette.ItemView.extend({
		tagName: 'div',
		template: JST.RoundTipsStat,
		data: {},
		initialize: function() {
			this.rounds     = this.getOption('rounds');
			this.squads     = this.getOption('squads');
			this.collection = this.getOption('collection');
			this.getting_data = false;

			var collections = [this.squads, this.rounds],
				complete = _.invoke(collections, 'fetch', {cache: true, expires: 60 });

			$.when.apply(null, complete).done(_.bind(function() {
				this.setSelectedRound();
			}, this));

			this.listenTo(APP.vent, 'tipping:round:change', this.setRoundId.bind(this));
		},

		setSelectedRound: function() {
			this.rounds.invoke('set', {"selected": false});

			this.round_id = this.rounds.getActualRoundId();
			this.getStats();

			return this;
		},

		onDestroy: function(){
			this.hidePreloader();
		},

		setRoundId: function(round_id) {

			this.round_id = round_id;

			this.getStats();

			return this;
		},

		getStats: function() {
			if (this.isDestroyed) {
				return false;
			}
			$
				.when
				.call(null, this.collection.getStats(this.round_id).fetch({is_project_json: true, cache: true, expires: 60 }))
				.done(_.bind(function() {
					this.setStats();
				}, this));

			return this;
		},

		setStats: function() {
			this.setTemplateData({
				tips: this.collection.toJSON(),
				round_id: this.round_id
			});
			return this;
		},

		setTemplateData: function(obj) {
			this.model.set(obj);
			this.getting_data = true;
			this.render();
			return this;
		}
	})

}(window, APP, Backbone, Marionette, $, _));

